import React from 'react';

function Profile() {
  return (
    <div className="bg-yellow-300 min-h-screen d-flex flex-column justify-content-center align-items-center">
      <h2 className="text-3xl text-white font-semibold mb-4">User Profile</h2>
      {/* Display user information, orders, settings, etc. */}
    </div>
  );
}

export default Profile;